import React, { useState, useEffect } from 'react'
import { Link } from 'react-router-dom'
import swal from 'sweetalert2'
import Preloader from '../preloader/Preloader'
import $ from 'jquery'

//components
import { getLineItems, deleteLineItem } from 'src/services/lineItems'
import { DataTableItem, UserRoute, BreadCrumb, Card } from 'src/components'

function LineItems() {
  const [loading, setLoading] = useState(true)
  const [quantityList, setQuantityList] = useState([])

  useEffect(() => {
    getLineItems()
      .then((res) => {
        if (res.data.status === 200) {
          setQuantityList(res.data.line_item)
        }
        setTimeout(() => {
          $('#dataTable').DataTable({
            scrollX: false,
            pageLength: 100,
          })
        }, 10)
        setLoading(false)
      })
      .catch(() => {
        setTimeout(() => {
          $('#dataTable').DataTable({
            scrollX: false,
            pageLength: 100,
          })
        }, 10)
        setLoading(false)
      })
  }, [])

  const deleteAgent = (e, id) => {
    e.preventDefault()

    const thisClicked = e.currentTarget

    swal
      .fire({
        title: 'Are you sure you want to proceed?',
        text: 'This will completely delete the line item permanently',
        icon: 'warning',
        showDenyButton: true,
        denyButtonText: 'Cancel!',
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        confirmButtonText: 'Yes, Proceed!',
      })
      .then((result) => {
        if (result.isConfirmed) {
          deleteLineItem(id)
            .then((res) => {
              if (res.data.status === 200) {
                swal.fire('Deleted!', 'Line item has been deleted', 'success')
                thisClicked.closest('tr').remove()
              } else if (res.data.status === 404) {
                swal.fire('Error', res.data.message, 'error')
              }
            })
            .catch((error) => {
              // Handle any errors here
              swal.fire('Error', error.message, 'error')
            })
        } else if (result.isDenied) {
          swal.fire('Not Deleted', '', 'info')
        }
      })
  }

  const renderRowActions = (item) => {
    return (
      <>
        <Link to={`/line_items/update/${item.id}`} className="btn btn-info me-2">
          Edit
        </Link>
        <button onClick={(e) => deleteAgent(e, item.id)} className="btn btn-danger">
          Delete
        </button>
      </>
    )
  }

  const columns = [
    { label: 'Name', key: 'name' },
    { label: 'Xero Code', key: 'xero_code' },
    // ... other columns
  ]

  const title = 'Additional Line Items'

  const breadcrumb = [
    {
      title: title,
      name: 'Add line items',
    },
  ]

  const buttonValues = [
    {
      title: 'Add line items',
      variants: 'btn btn-primary my-3 mr-2',
      routes: '/line_items/create',
    },
  ]

  const cardValues = [
    {
      title: title,
    },
  ]

  return (
    <div>
      <BreadCrumb data={breadcrumb} />
      <UserRoute data={buttonValues} />

      <Card data={cardValues}>
        {
          <DataTableItem
            data={quantityList}
            columns={columns}
            renderRowActions={renderRowActions}
          />
        }
      </Card>
    </div>
  )
}

export default LineItems
